module.exports = __webpack_public_path__ + "static/media/fractureplating.d4703a07.png";